var _rect, _g, _rect2, _path, _rect3, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicLockIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 197,
    height: 155,
    viewBox: "0 0 197 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 165,
    height: 129,
    rx: 11.76,
    fill: "url(#paint0_linear_2128_6022)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2128_6022)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 8,
    width: 149,
    height: 113,
    rx: 8,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 77,
    y: 13,
    width: 75,
    height: 5,
    rx: 2.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.1361 44H143.174C149.705 44 155 49.2947 155 55.8261V55.8261C155 62.3575 149.705 67.6522 143.174 67.6522H82.1739C75.4504 67.6522 70 73.1026 70 79.8261V79.8261C70 86.5496 75.4504 92 82.1739 92H140.414",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0625,
    y: 70.0117,
    width: 83.9821,
    height: 84.1061,
    rx: 16,
    fill: "url(#paint1_linear_2128_6022)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 110.25H29.75C27.817 110.25 26.25 111.817 26.25 113.75V126C26.25 127.933 27.817 129.5 29.75 129.5H54.25C56.183 129.5 57.75 127.933 57.75 126V113.75C57.75 111.817 56.183 110.25 54.25 110.25Z",
    stroke: "white",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 110.25V103.25C33.25 100.929 34.1719 98.7038 35.8128 97.0628C37.4538 95.4219 39.6794 94.5 42 94.5C44.3206 94.5 46.5462 95.4219 48.1872 97.0628C49.8281 98.7038 50.75 100.929 50.75 103.25V110.25",
    stroke: "white",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2128_6022",
    x: 21.0571,
    y: -10.9429,
    width: 186.886,
    height: 150.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2128_6022"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2128_6022",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2128_6022",
    x1: 114.5,
    y1: 0,
    x2: 114.5,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2128_6022",
    x1: 11.5328,
    y1: 124.024,
    x2: 75.194,
    y2: 107.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicLockIllustration);
export default __webpack_public_path__ + "static/media/sonic-lock-illustration.5d3bacaad0ba806dddbc2d9670212777.svg";
export { ForwardRef as ReactComponent };